import React from "react";

import { FeaturedImage, PublishDate, Excerpt, Body } from "newsItemHelpers";
import styles from "./NewsItem.scss";

const NewsItemView = props => {
  const { data, settings } = props;

  if (data && data.items && data.items.length > 0) {
    let item = data.items[0];

    return (
      <article>
        <header className={`news-article__header`}>
          <h1 className={`news-article__title`}>{item.subjectTitle}</h1>
        </header>
        <div className={`news-article__content ${styles.content}`}>
          {settings.showDate && item.postDate && (
            <PublishDate
              date={item.postDate}
              lang={settings.lang}
              className={`news-article__pubDate`}
            />
          )}
          {settings.showModalImage &&
            item.featuredImageref &&
            item.featuredImageref.file &&
            item.featuredImageref.file.url && (
              <FeaturedImage
                data={item}
                fallbackImage={settings.fallbackImage}
                className={`news-article__image ${styles.image}`}
              />
            )}
          {settings.showExcerpt && item.excerpt && (
            <Excerpt
              content={item.excerpt}
              className={`news-article__excerpt`}
            />
          )}
          {item.body && (
            <Body content={item.body} className={`news-article__body`} />
          )}
        </div>
      </article>
    );
  } else {
    // Prevent inifinite redirect loops
    if (
      settings.slug !== settings.redirectErrorUrl &&
      location.pathname !== settings.redirectErrorUrl
    ) {
      window.location = settings.redirectErrorUrl;
    }

    return null;
  }
};

export default NewsItemView;
